import { useSyncExternalStore } from 'react';
import { useAppContext } from '@/context/AppContext/AppContext';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

export default function useAIAddon(): boolean {
  const { adminAppStore } = useAppContext();
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isAIFeatureAddOnFlagEnabled = featureFlags[FeatureFlagKeys.Use_AI_Feature_AddOn];

  if (!isAIFeatureAddOnFlagEnabled) {
    return true;
  }

  return Boolean(adminAppStore.getters?.['orgPricingConfig/getIsAiFeaturesEnabled']);
}
